<app-navbar title="Métricas Apostadores" />

<div class="py-8 px-4 overflow-y-auto max-h-[calc(100vh-5rem)] scrollbar-hide">
  <app-card>
    <app-card-header title="Métricas Apostadores">
      <div class="flex flex-1 items-center justify-end flex-wrap gap-3">
        <form [formGroup]="filterForm" (ngSubmit)="applyFilters()" class="flex items-center gap-3 flex-wrap">
          <p-floatlabel variant="on">
            <p-datepicker
              formControlName="start_date"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              inputId="bettors_start_date"
              appendTo="body"
            />
            <label for="bettors_start_date">Data Inicial</label>
          </p-floatlabel>

          <p-floatlabel variant="on">
            <p-datepicker
              formControlName="end_date"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              inputId="bettors_end_date"
              appendTo="body"
            />
            <label for="bettors_end_date">Data Final</label>
          </p-floatlabel>

          <p-floatlabel variant="on">
            <input
              id="bettors_user_id"
              pInputText
              formControlName="user_id"
              placeholder=" "
            />
            <label for="bettors_user_id">ID do Apostador</label>
          </p-floatlabel>

          <p-button
            label="Consultar"
            icon="fa-solid fa-filter"
            type="submit"
            [loading]="loading()"
            size="small"
          />
        </form>
      </div>
    </app-card-header>

    @if (!firstRequest() && meta(); as bettorsMeta) {
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-4 mb-6 px-2">
        <div class="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <div class="text-sm text-blue-600 font-medium">Total de Registros</div>
          <div class="text-2xl font-bold text-blue-800 mt-1">{{ bettorsMeta.total_records }}</div>
        </div>
        <div class="bg-cyan-50 border border-cyan-200 rounded-xl p-4">
          <div class="text-sm text-cyan-600 font-medium">Registros na Página</div>
          <div class="text-2xl font-bold text-cyan-800 mt-1">{{ bettorsMeta.page_records }}</div>
        </div>
        <div class="bg-emerald-50 border border-emerald-200 rounded-xl p-4">
          <div class="text-sm text-emerald-600 font-medium">FTDs na Página</div>
          <div class="text-2xl font-bold text-emerald-800 mt-1">{{ totalFtdOnPage() }}</div>
        </div>
        <div class="bg-amber-50 border border-amber-200 rounded-xl p-4">
          <div class="text-sm text-amber-600 font-medium">Depósitos na Página</div>
          <div class="text-2xl font-bold text-amber-800 mt-1">{{ totalDepositsOnPage() | currency: 'BRL' : 'symbol' : '1.2-2' }}</div>
        </div>
        <div class="bg-rose-50 border border-rose-200 rounded-xl p-4">
          <div class="text-sm text-rose-600 font-medium">Saques na Página</div>
          <div class="text-2xl font-bold text-rose-800 mt-1">{{ totalWithdrawalsOnPage() | currency: 'BRL' : 'symbol' : '1.2-2' }}</div>
        </div>
        <div class="bg-violet-50 border border-violet-200 rounded-xl p-4">
          <div class="text-sm text-violet-600 font-medium">UTM Source</div>
          <div class="text-lg font-bold text-violet-800 mt-1 break-all">{{ bettorsMeta.utm_source }}</div>
        </div>
      </div>

      <div class="mb-4 px-2 text-sm text-zinc-500 flex flex-wrap gap-x-6 gap-y-2">
        <span>Período: <strong class="text-zinc-700">{{ bettorsMeta.start_date }}</strong> até <strong class="text-zinc-700">{{ bettorsMeta.end_date }}</strong></span>
        <span>Página: <strong class="text-zinc-700">{{ bettorsMeta.current_page }}</strong> de <strong class="text-zinc-700">{{ bettorsMeta.last_page }}</strong></span>
        <span>Faixa retornada: <strong class="text-zinc-700">{{ bettorsMeta.from }}</strong> - <strong class="text-zinc-700">{{ bettorsMeta.to }}</strong></span>
      </div>
    }

    @if (loading()) {
      <div class="flex items-center justify-center py-20">
        <p-progressSpinner strokeWidth="3" />
      </div>
    }

    @else if (firstRequest()) {
      <div class="flex flex-col items-center justify-center py-20 text-zinc-400">
        <i class="fa-solid fa-arrow-trend-up text-4xl mb-4"></i>
        <p class="text-lg">A consulta usa sua UTM autenticada e retorna os apostadores do período informado.</p>
      </div>
    }

    @else if (!data().length) {
      <div class="flex flex-col items-center justify-center py-10 text-zinc-400">
        <div class="h-44">
          <ng-lottie [options]="emptyLottieOptions" />
        </div>
        <p>Nenhum apostador encontrado para os filtros informados.</p>
      </div>
    }

    @else {
      <p-table [value]="data()" [tableStyle]="{ 'min-width': '88rem' }">
        <ng-template #header>
          <tr>
            <th class="text-start text-sm">ID Apostador</th>
            <th class="text-start text-sm">Nome</th>
            <th class="text-start text-sm">Data de Cadastro</th>
            <th class="text-center text-sm">Fez FTD</th>
            <th class="text-end text-sm">Valor FTD</th>
            <th class="text-end text-sm">Depósitos</th>
            <th class="text-end text-sm">Saques</th>
          </tr>
        </ng-template>
        <ng-template #body let-item>
          <tr>
            <td class="text-sm font-mono">{{ item.id_apostador }}</td>
            <td class="text-sm font-medium text-zinc-800">{{ item.nome_apostador }}</td>
            <td class="text-sm text-zinc-600">{{ item.data_cadastro | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td class="text-center">
              <p-tag [value]="hasFtd(item) ? 'Sim' : 'Não'" [severity]="hasFtd(item) ? 'success' : 'secondary'" />
            </td>
            <td class="text-sm text-end font-semibold">{{ item.valor_ftd | currency: 'BRL' : 'symbol' : '1.2-2' }}</td>
            <td class="text-sm text-end">
              <div class="font-semibold text-zinc-800">{{ item.valor_depositos | currency: 'BRL' : 'symbol' : '1.2-2' }}</div>
              <small class="text-zinc-500">{{ item.qtd_depositos }} {{ item.qtd_depositos === 1 ? 'depósito' : 'depósitos' }}</small>
            </td>
            <td class="text-sm text-end">
              <div class="font-semibold text-zinc-800">{{ item.valor_saques | currency: 'BRL' : 'symbol' : '1.2-2' }}</div>
              <small class="text-zinc-500">{{ item.qtd_saques }} {{ item.qtd_saques === 1 ? 'saque' : 'saques' }}</small>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="7" class="text-center">
              <div class="h-44 p-4 text-zinc-500">
                <ng-lottie [options]="emptyLottieOptions" />
                Nenhum registro encontrado.
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #footer>
          <tr>
            <td colspan="7">
              <div class="w-full flex justify-end">
                <p-paginator
                  (onPageChange)="onPageChange($event)"
                  [rows]="rows"
                  [first]="(page - 1) * rows"
                  [totalRecords]="totalRecords"
                  [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[50, 100, 250, 500, 1000, 5000]"
                  currentPageReportTemplate="{first} - {last} de {totalRecords}"
                  appendTo="body"
                />
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </app-card>
</div>